import React from "react";
import { COMPANY } from "../../lib/siteData";

const WhatsAppButton = () => {
  const href = `https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(COMPANY.whatsappMessage)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer noopener"
      aria-label="Contact Waves Technology on WhatsApp"
      data-testid="whatsapp-floating-button"
      className="fixed bottom-6 right-6 z-[60] inline-flex items-center gap-2.5 bg-[#25D366] hover:bg-[#1FB857] text-white shadow-xl transition-all hover:translate-y-[-2px] px-4 py-3 lg:px-5 lg:py-3.5 font-semibold text-sm"
    >
      <svg viewBox="0 0 32 32" className="w-5 h-5 lg:w-6 lg:h-6 shrink-0" fill="currentColor" aria-hidden="true">
        <path d="M19.11 17.27c-.27-.13-1.6-.79-1.85-.88-.25-.09-.43-.13-.61.13-.18.27-.71.88-.87 1.06-.16.18-.32.2-.59.07-.27-.13-1.14-.42-2.17-1.34-.8-.71-1.34-1.59-1.5-1.86-.16-.27-.02-.42.12-.55.12-.12.27-.32.4-.48.13-.16.18-.27.27-.45.09-.18.04-.34-.02-.47-.07-.13-.61-1.46-.83-2-.22-.53-.45-.46-.61-.47-.16-.01-.34-.01-.52-.01-.18 0-.47.07-.71.34-.25.27-.94.92-.94 2.24 0 1.32.96 2.6 1.1 2.78.13.18 1.89 2.88 4.59 4.04.64.28 1.14.45 1.53.58.64.2 1.23.17 1.69.1.52-.08 1.6-.65 1.83-1.28.23-.63.23-1.17.16-1.28-.07-.11-.25-.18-.52-.31zM16 4C9.37 4 4 9.37 4 16c0 2.11.55 4.09 1.51 5.81L4 28l6.32-1.49A11.93 11.93 0 0016 28c6.63 0 12-5.37 12-12S22.63 4 16 4z" />
      </svg>
      <span className="hidden sm:inline-block uppercase tracking-[0.12em] text-xs lg:text-sm whitespace-nowrap">Chat on WhatsApp</span>
    </a>
  );
};

export default WhatsAppButton;
